var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-control-products-type-id-container" },
    [
      _setup.typeTitle && !_setup.showMenu
        ? _c(_setup.FormControlPlainText, {
            attrs: { value: _setup.typeTitle, "form-id": _vm.formId },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.showMenu
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentData[_vm.field.name],
                  expression: "currentData[field.name]",
                },
              ],
              staticClass: "form-select mb-2",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.currentData,
                    _vm.field.name,
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(_setup.options, function (option) {
              return _c(
                "option",
                { key: option.value, domProps: { value: option.value } },
                [_vm._v("\n            " + _vm._s(option.text) + "\n        ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.currentData.typeId && !_setup.showSaveNotice
        ? _c(
            "button",
            {
              staticClass: "btn btn-light btn-sm",
              attrs: {
                disabled: !_setup.showEditVariationsButton,
                type: "button",
              },
              on: { click: _setup.editVariations },
            },
            [_vm._v("\n        Edit variations\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.showSaveNotice
        ? _c("small", { staticClass: "text-warning ms-2" }, [
            _c("em", [_vm._v("Save required")]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }